import React from 'react';
import { Users, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AssignedUserSelect } from '@/components/AssignedUserSelect';
import { isAssignableAssignedUser } from '@/components/assigned-user.utils';
import type { UserOption } from '@/otros-tramites/services/otrosTramitesService';

interface AssignedUserFilterProps {
  assignedUser: UserOption | null;
  onAssignedUserChange: (user: UserOption | null) => void;
  onClearFilter: () => void;
}

const AssignedUserFilter: React.FC<AssignedUserFilterProps> = ({
  assignedUser,
  onAssignedUserChange,
  onClearFilter,
}) => {
  return (
    <div className="flex flex-col gap-3 rounded-lg border bg-gray-50 p-4 sm:col-span-2">
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4" />
        <span className="text-sm font-medium">Filtro por asignado</span>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex flex-col gap-2 w-full">
          <label className="text-xs font-medium text-gray-600">Usuario asignado</label>
          <div className="w-full">
            <AssignedUserSelect
              value={assignedUser}
              onChange={onAssignedUserChange}
              placeholder="Buscar usuario asignado"
              ariaLabel="Usuario asignado"
              filterOption={isAssignableAssignedUser}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignedUserFilter;
